import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import Vue from 'vue';
import PageState from '../store/state';
import to from 'await-to-js';
import { toPublishPage } from '../utils/util';
import { MiguConfig } from '../utils/constant';
import { toast } from '@/utils/util'
import CreateDrawer from '../components/createDrawer.vue';
import SubscribePopup from '../components/subscribePopup.vue';
import AgreementDialog from '../components/agreementDialog.vue';

/**components**/
@Component({
  components: {
    CreateDrawer,
    SubscribePopup,
    AgreementDialog,
  },
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class worksPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;

  // 筛选项数据
  showFilters = false;
  styles = [];
  type = '全部类型';
  date = '全部日期';
  dateValue = '全部日期';
  activeKey: any = 0;
  activeValue = '全部类型';
  minDate = new Date('2000-01-01')
  showTypesPopover: boolean = false;
  showDatePopover: boolean = false;
  show = false;

  // 列表数据
  loading: Boolean = false;
  finished: Boolean = true;
  pageIndex: any = 0;
  pageSize: any = 12;
  total_pages: any = 0;
  works = [];
  statusUpdateQueue = []; // 需要进行状态轮询的队列
  statusUpdateTimer = null;
  articleIdMigu = '';

  imgDarkDefault = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/default_1706873947201.png';
  iconDel = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/del_icon_1706873947201.png'
  iconEdit = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/edit_icon_1706873947201.png';
  iconDownload = 'https://tc-nj-backend-ms-pub-cdn.mobvoi.com/baohuo-mp-cdn/cdnData/images/baohuo/download_icon_1706873947201.png'
  imgLightDefault = '/images/migu/newYear/default_cover.png';

  showCreateDrawer: boolean = false;
  isSubmiting: boolean = false;
  showLoginPopup: boolean = false;
  showSubscribePopup: boolean = false;
  // ============ 协议弹窗（抽屉勾选框点协议名触发） ============
  showAgreementPopup: boolean = false;
  drawerOpenBeforeAgreement: boolean = false; // 弹协议前抽屉是否打开（关闭协议后恢复）
  drawerAgreed: boolean = false; // 协议勾选状态（弹窗点「我已阅读并同意」后置 true，同步进抽屉）
  taskId: string = '';

  // 创作抽屉回显数据（从发音人搜索页返回后恢复）
  drawerText = '';
  drawerStyleCode = '';
  drawerSpeakerName = '';
  drawerSpeakerStyleId: number = 0;
  drawerSpeakerStyleName = '';
  drawerSpeechSpeed = '';

  // 弹窗状态
  showDeleteDialog: boolean = false;
  showActionSheet: boolean = false;
  showDetailDialog: boolean = false;
  detailData: any = {};
  currentItem: any = null;
  get isNewYear() {
    return localStorage.getItem('theme') === 'New_Year';
  }
  get theme() {
    return localStorage.getItem('theme') || '';
  }
  get imgDefault() { return this.isNewYear ? this.imgLightDefault : this.imgDarkDefault }

  @Watch('statusUpdateQueue', { deep: true })
  listenStatusUpdateQueue() {
    if (this.statusUpdateTimer) return;
    this.queryArticleStatusBatch();
  }

  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
    localStorage.removeItem('ww_token');
    localStorage.setItem('isMigu', 'true');
  }
  mounted() {
    this.upLoadData();
    document.title = '创作记录';
    this.articleIdMigu = localStorage.getItem('articleIdMigu')||'';
    // this.taskId = localStorage.getItem('creationTaskIdMigu') || '';
    // 从咪咕 taskId 页返回：消费 taskId 并直接触发提交
    this.setTaskId();
    // 从发音人搜索页返回：恢复抽屉打开状态和草稿
    this.restoreCreateDrawer();
  }

  // 恢复创作抽屉（发音人搜索页选完发音人返回时）
  restoreCreateDrawer() {
    const reopen = localStorage.getItem('createDrawerReopen');
    if (reopen !== 'true') return;
    localStorage.removeItem('createDrawerReopen');
    const data = JSON.parse(localStorage.getItem('createDrawerMiguData') || 'null');
    if (data) {
      this.drawerText = data.text || '';
      this.drawerStyleCode = data.styleCode || '';
      this.drawerSpeakerName = data.speakerName || '';
      this.drawerSpeakerStyleId = data.speakerStyleId || 0;
      this.drawerSpeakerStyleName = data.speakerStyle || '';
      this.drawerSpeechSpeed = data.speechSpeed || '';
    }
    this.showCreateDrawer = true;
  }
  beforeDestroy() {
    clearTimeout(this.statusUpdateTimer);
  }

  //加载更多数据
  upLoadData() {
    if (this.pageIndex <= this.total_pages) {
      this.pageIndex = this.pageIndex + 1;
      this.getWorks();
    }
  }

  // 空列表「去创作」：跳转首页（带主题，避免首页 query.theme 默认 White 覆盖当前主题）
  toCreate() {
    this.$router.push({
      path: '/migu',
      query: this.theme ? { theme: this.theme } : {}
    });
  }

  // 删除作品（触发逻辑后边再补）
  onDelete(item: any) {
    this.currentItem = item;
    this.showDeleteDialog = true;
  }

  // 确认删除
  confirmDelete() {
    if (!this.currentItem?.articleId) {
      this.showDeleteDialog = false;
      return;
    }
    const articleId = this.currentItem.articleId;
    // post 请求的 query 参数需通过 params 字段拼 URL（见 store.ts ajax 的 post 分支）
    this.$http('deleteArticle', { params: { articleId }, body: {} }).then((res: any) => {
      this.showDeleteDialog = false;
      if (res.code === 200) {
        toast('已删除');
        // 从列表移除
        this.works = this.works.filter(item => item.articleId !== articleId);
        this.currentItem = null;
        // 若列表删空，回到空态
        if (this.works.length === 0 && this.finished) {
          this.upLoadData();
        }
      } else {
        toast(res.message || '删除失败');
      }
    }).catch(() => {
      this.showDeleteDialog = false;
      toast('删除失败');
    });
  }

  // 三点菜单
  onMoreMenu(item: any) {
    this.currentItem = item;
    this.showActionSheet = true;
  }

  // 返回上一页
  goBack() {
    this.$router.back();
  }

  // 作品已出结果（非生成中）：才允许再次创作/删除
  get actionItemSettled() {
    const sv = this.currentItem?.statusValue;
    return sv === 'success' || sv === 'fail';
  }

  // 查看详情：拉取作品详情，弹窗展示任务信息
  async onActionView() {
    const item = this.currentItem;
    this.showActionSheet = false;
    if (!item?.articleId) return;
    const [err, res] = await to(this.$http('getArticleDetail', { articleId: item.articleId }));
    if (err || res.code !== 200 || !res.data) {
      toast((err || res)?.message || '获取详情失败，请稍后重试');
      return;
    }
    // 详情字段优先，列表字段兜底
    this.detailData = {
      ...item,
      ...res.data,
      // 保留列表侧格式化好的状态文案
      statusValue: item.statusValue,
      statusValueName: item.statusValueName,
    };
    this.showDetailDialog = true;
  }

  // 玩法模版标题：title 截断算法
  // 1. 取前 12 个字；若其中有句号/感叹号，取第一个句号/感叹号之前的文本（不含标点）
  // 2. 否则从这 12 字倒序找逗号，截取最后一个逗号之前的文本（不含逗号）
  get templateTitle() {
    const title = (this.detailData?.title || '').trim();
    if (!title) return '-';
    const head = title.slice(0, 14);
    // 句号/感叹号（含英文感叹号；不含英文句点，避免误截数字如 3.5）
    const sentenceMatch = head.match(/^(.*?)[。！!]/);
    if (sentenceMatch && sentenceMatch[1]) {
      return sentenceMatch[1];
    }
    // 倒序找逗号（中英文都兼容），截取最后一个逗号之前的文本
    const commaIdx = Math.max(head.lastIndexOf('，'), head.lastIndexOf(','));
    if (commaIdx > 0) {
      return head.slice(0, commaIdx);
    }
    return head;
  }

  onActionRecreate() {
    this.showActionSheet = false;
    const item = this.currentItem;
    if (!item?.articleId) return;
    // 再次创作：拉作品详情，把文案/风格/发音人参数带入创作抽屉
    this.fillDrawerFromWork(item);
  }

  // 卡片上的「再次创作」按钮
  onCardRecreate(item: any) {
    if (!item?.articleId) return;
    this.fillDrawerFromWork(item);
  }

  // 拉取作品详情并填充抽屉回显数据
  // 详情结构与 textToVideo 的 articleDetail 一致：创作参数在 res.data.extendVO 里
  // 注意：extendVO.speakerName 可能是「魔云熙|冷静」格式，需取 | 前的发音人名
  async fillDrawerFromWork(item: any) {
    // 清掉可能残留的发音人选中缓存，避免覆盖「再次创作」带入的参数
    localStorage.removeItem('createDrawerCurrSpeaker');
    localStorage.removeItem('createDrawerReopen');
    const [err, res] = await to(this.$http('getArticleDetail', { articleId: item.articleId }));
    const detail = (!err && res && res.code === 200 && res.data) ? res.data : null;
    const extendVO = (detail && detail.extendVO) || {};
    // 详情拉取失败时也直接打开抽屉，用列表字段兜底，不打断「再次创作」操作
    // 字段容错映射：extendVO（详情标准结构）→ detail 顶层 → 列表 item
    const pick = (...keys: string[]) => {
      for (const key of keys) {
        const val = [extendVO, detail, item].reduce((acc, src) => {
          if (acc !== undefined && acc !== null && acc !== '') return acc;
          return src ? src[key] : undefined;
        }, undefined);
        if (val !== undefined && val !== null && val !== '') return val;
      }
      return '';
    };
    this.drawerText = pick('originContent', 'content', 'text');
    this.drawerStyleCode = pick('styleCode', 'styleEN');
    // speakerName 可能是「魔云熙|冷静」格式，取 | 前的发音人名
    const speakerName = pick('speakerName');
    this.drawerSpeakerName = String(speakerName).split('|')[0];
    this.drawerSpeakerStyleId = 0; // 详情无风格id，由 styleName 在情绪列表中匹配
    // speakerStyle 若带「魔雨晴|冷静」前缀，取 | 后的纯风格名（与情绪列表 moodName 对齐）
    const speakerStyle = String(pick('speakerStyle', 'moodName'));
    this.drawerSpeakerStyleName = speakerStyle.includes('|') ? speakerStyle.split('|')[speakerStyle.split('|').length - 1] : speakerStyle;
    // 语速可能返回数字（1），统一转 "1.0" 字符串，避免显示成「1倍速」
    const speed = pick('speechSpeed', 'speakerSpeed');
    this.drawerSpeechSpeed = (speed === '' || speed === undefined) ? '' : Number(speed).toFixed(1);
    console.log('fillDrawerFromWork', { detail, extendVO, drawerText: this.drawerText, styleCode: this.drawerStyleCode, speaker: this.drawerSpeakerName, style: this.drawerSpeakerStyleName, speed: this.drawerSpeechSpeed });
    this.showCreateDrawer = true;
  }

  onActionDelete() {
    this.showActionSheet = false;
    this.showDeleteDialog = true;
  }

  // ============ 创作抽屉提交逻辑 ============

  // 检查登录
  checkLogin() {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      const btoken = localStorage.getItem('btoken');
      if (!btoken) {
        this.showLoginPopup = true;
        return false;
      }
    }
    return true;
  }

  // 提交前验证（对齐 textToVideo.beforeSumitVerify：基础校验 + 上一个任务状态检查）
  async beforeSubmitVerify(params: any) {
    if (!params.originContent) {
      toast('请输入文案');
      return false;
    }
    if (params.originContent.length < 35) {
      toast('请输入至少35个字');
      return false;
    }
    if (!params.speaker) {
      toast('请选择发音人');
      return false;
    }
    // 上一个任务未完成（非失败/成功导出终态）时，不允许重复提交
    const lastArticleId = localStorage.getItem('miguLastArticleId');
    if (lastArticleId) {
      const [error, res] = await to(this.$http('getArticleStatus', { articleId: lastArticleId }));
      if (!error && res.code === 200 && res.data) {
        const status = res.data.status; // 5失败, 6成功
        const lastExportTaskStatus = res.data.lastExportTaskStatus; // 2成功,3/4失败
        if (status === 5 || (status === 6 && [2, 3, 4].includes(lastExportTaskStatus))) {
          localStorage.removeItem('miguLastArticleId');
        } else {
          toast('已有处理中的任务, 请稍后再次提交');
          return false;
        }
      }
    }
    return true;
  }

  // 抽屉提交（对齐 textToVideo.doSubmit：async 验证 + await getMiguToken）
  async onDrawerSubmit(params: any) {
    console.log('onDrawerSubmit')
    if (this.isSubmiting) return;
    if (!this.checkLogin()) return;
    const verify = await this.beforeSubmitVerify(params);
    if (!verify) return;
    this.isSubmiting = true;

    params.creationTaskId = this.taskId;
    params.title = params.originContent.slice(0, 80);
    params.platform = 'MIGU';
    params.resourceType = 'ONE_CLICK';
    params.articleTransform = 0;

    try {
      if ((window as any).getMiguToken) {
        const rcToken = await (window as any).getMiguToken();
        params.rcToken = rcToken;
      }
    } catch (e) {
      console.error('getMiguToken error', e);
    }

    this.doSubmitRequest(params);
  }

  doSubmitRequest(params: any) {
    params.channelCode = MiguConfig.schannel;
    this.$http('submitCreate', params).then((res: any) => {
      this.isSubmiting = false;
      if (res.code == 200) {
        this.isSubmiting = true;
        try {
          if ((window as any)._amberTrack) {
            localStorage.setItem('creationTaskIdMigu', params.creationTaskId + '');
            const vuid = localStorage.getItem('vuid') || '';
            (window as any)._amberTrack('music_aigc_submit_task', [
              { EK: 'triggerType', EV: '2' },
              { EK: 'scene', EV: MiguConfig.projectId },
              { EK: 'taskId', EV: params.creationTaskId },
              { EK: 'vuid', EV: vuid },
              { EK: 'appId', EV: MiguConfig.appid },
              { EK: 'channel', EV: MiguConfig.schannel }
            ], true, 'beacon');
          }
        } catch (e) {}
        localStorage.setItem('miguLastArticleId', res.data.articleId + '');
        this.showCreateDrawer = false;
        this.$router.push({ path: '/audioCreating', query: { articleId: res.data.articleId, source: 'app_migu' } });
      } else if (res.message == '请先登录') {
        this.doLogin();
      } else {
        toast(res.message);
      }
    }).catch((err: any) => {
      this.isSubmiting = false;
      if (err?.response?.data?.message === 'token错误请重新登录') {
        this.doLogin();
      }
    });
  }

  // 查询 taskId
  // 对齐 textToVideo 的 queryTaskId：跳转前存提交标记和参数，回来后由 setTaskId 触发提交
  async onDrawerQueryTask() {
    console.log('onDrawerQueryTask')
    if (this.taskId) {
      const drawerRef = this.$refs.createDrawerRef as any;
      if (drawerRef) drawerRef.doCreateSubmit();
      return;
    }
    if (!this.checkLogin()) return;

    // 跳转前校验参数（对齐 textToVideo 的 beforeSumitVerify），避免空参数白跳一趟
    const drawerRef = this.$refs.createDrawerRef as any;
    const submitParams = drawerRef ? drawerRef.submitParams : {};
    const verify = await this.beforeSubmitVerify(submitParams);
    if (!verify) return;

    this.setLocalStorageData(); // 草稿回显（回来后恢复抽屉用）
    // 存提交标记 + 提交参数，跳转回来后 setTaskId 直接触发提交
    localStorage.setItem('isMiguSubmit', 'true');
    localStorage.setItem('worksMiguSubmitData', JSON.stringify(submitParams));
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');

    // 获取 btoken
    const btoken = localStorage.getItem('btoken') || '';

    // 根据 commonPub 标识决定使用哪个 URL（与 textToVideo.queryTaskId 一致的 taskId 页面）
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      let url = `https://y.migu.cn/app/v5/p/middle/ai-channel-task-id/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}`;
      if (btoken) {
        url += `&btoken=${btoken}`;
      }
      url += '&pm=hash#/task-id';
      window.location.href = url;
    } else {
      window.location.href = `https://y.migu.cn/app/v5/p/ai-charging/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}&pm=hash#/task-id`;
    }
  }

  // 设置taskId（从咪咕 taskId 页返回后触发提交，对齐 textToVideo 的 setTaskId）
  setTaskId() {
    const isMiguSubmit = localStorage.getItem('isMiguSubmit');
    if (!isMiguSubmit) return; // 不是提交过来的，不去取taskId
    const query = this.$route.query;
    const taskId = query.taskId || '';
    if (typeof taskId === 'string') this.taskId = taskId; // 空值不覆盖已缓存的 taskId
    if (!taskId) {
      const resumeCode = query.resumeCode || '';
      // 用户支付状态码0：用户支付失败, 1：用户支付成功, 2：用户取消支付, 3：用户已有次数, 4：获取taskId失败
      const error = query.info as string;
      if (resumeCode  === '4') {
        let msg = error || '获取taskId失败';
        if (msg.includes('存在进行中的任务')) msg = '存在进行中的任务';
        toast(msg, 'middle', 5000);
      } else if (resumeCode === '2') {
        toast(error || '您已取消支付');
      } else if (resumeCode === '0') {
        toast(error || '支付失败');
      }
      // 失败/取消：清标记并恢复抽屉，用户可修改后重试
      localStorage.removeItem('isMiguSubmit');
      localStorage.setItem('createDrawerReopen', 'true');
      this.restoreCreateDrawer();
      return;
    }
    // 有taskId：读取跳转前存的提交参数，直接触发提交
    const data = JSON.parse(localStorage.getItem('worksMiguSubmitData') || 'null');
    localStorage.removeItem('isMiguSubmit');
    if (!data) return;
    data.creationTaskId = taskId;
    // 同步保存 taskId，后续生成完成的埋点轮询用
    // localStorage.setItem('creationTaskIdMigu', taskId + '');
    this.onDrawerSubmit(data);
  }

  // 登录
  doLogin() {
    this.showCreateDrawer = false;
    this.setLocalStorageData();
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');
    const btoken = localStorage.getItem('btoken') || '';
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      window.location.href = `https://y.migu.cn/app/v5/p/middle/ai-channel-token/index.html?appId=${MiguConfig.appid}&schannel=${MiguConfig.schannel}&projectId=${MiguConfig.projectId}&releaseId=75348636&cburl=${encodeURIComponent('https://h5.yuan365.com/#/migu')}&pm=hash&cToken=${btoken}`;
    }
  }

  // 保存草稿
  setLocalStorageData() {
    const drawerRef = this.$refs.createDrawerRef as any;
    if (drawerRef) {
      const params = drawerRef.saveParams;
      // 存到抽屉专用 key，与发音人搜索页 speakerInfo 的读写保持一致
      localStorage.setItem('createDrawerMiguData', JSON.stringify(params));
      // 同步到页面 state，抽屉销毁重建（v-if）后重开可回显
      this.drawerText = params.text || '';
      this.drawerStyleCode = params.styleCode || '';
      this.drawerSpeakerName = params.speakerName || '';
      this.drawerSpeakerStyleId = params.speakerStyleId || 0;
      this.drawerSpeakerStyleName = params.speakerStyle || '';
      this.drawerSpeechSpeed = params.speechSpeed || '';
    }
  }

  // 跳转付费
  doPay() {
    this.setLocalStorageData();
    const cburl = encodeURIComponent(window.location.href.split('?')[0]);
    localStorage.setItem('miguDidLogin', '1');
    window.location.href = `https://y.migu.cn/app/v5/p/ai-pay/index.html?appId=${MiguConfig.appid}&projectId=${MiguConfig.projectId}&cburl=${cburl}&schannel=${MiguConfig.schannel}&pm=hash`;
  }

  // 显示订购弹窗
  showSubscribe() {
    this.showSubscribePopup = true;
  }

  // 关闭订购弹窗
  closeSubscribe() {
    this.showSubscribePopup = false;
  }

  // ============ 协议弹窗（抽屉勾选框点协议名触发） ============

  // 勾选框点协议名：关闭抽屉（若打开），弹协议弹窗
  onShowAgreement() {
    this.drawerOpenBeforeAgreement = this.showCreateDrawer;
    if (this.showCreateDrawer) {
      this.showCreateDrawer = false;
    }
    this.showAgreementPopup = true;
  }

  // 协议弹窗点「我已阅读并同意」：自动勾选抽屉协议
  onAgreementAgree() {
    this.drawerAgreed = true;
  }

  // 关闭协议弹窗：恢复协议弹出前的抽屉打开状态
  onAgreementClose() {
    this.showAgreementPopup = false;
    if (this.drawerOpenBeforeAgreement) {
      this.showCreateDrawer = true;
      this.drawerOpenBeforeAgreement = false;
    }
  }

  toPlay(item) {
    const videoUrl = item.lastExportVideoUrl;
    const coverUrl = item.coverUrl;
    if (!videoUrl) return;
    this.$router.push({ path: '/video-play', query: { videoUrl, coverUrl, articleId: item.articleId, swipeable: '1' } });
  }
  async toPublish(item) {
    const obj: any = {
      videoUrl: item.lastExportVideoUrl,
      coverUrl: item.coverUrl,
    };
    if ((window as any)._amberTrack) {
      const vuid = localStorage.getItem('vuid') || '';
      (window as any)._amberTrack('music_aigc_publish_ringtone', [
        {
          EK: 'triggerType',
          EV: '2'
        },
        {
          EK: 'scene',
          EV: MiguConfig.projectId
        },
        {
          EK: 'videoUrl',
          EV: item.lastExportVideoUrl || ''
        },
        {
          EK: 'resId',
          EV: item.articleId || ''
        },
        {
          EK: 'vuid',
          EV: vuid
        },
        {
          EK: 'appId',
          EV: MiguConfig.appid
        },
        {
          EK: 'channel',
          EV: MiguConfig.schannel
        }
      ], true, 'beacon');
      console.log('_amberTrack music_aigc_publish_ringtone', {
        EK: 'videoUrl',
        EV: item.lastExportVideoUrl || ''
      },
      {
        EK: 'resId',
        EV: item.articleId || ''
      },
      {
        EK: 'vuid',
        EV: vuid
      });
    }
    setTimeout(async () => {
      await toPublishPage(obj);
    }, 200);
  }

  // status
  // INIT(0, "初始化", "初始化"),
  // LINE_UP(1, "排队中", "排队中"),
  // TEXT_EXTRACT_FEATURES(2, "文案获取角色特性", ""),
  // TEXT_GENERATE_IMG_PROMPTS(3, "文案生成图片prompt", ""),
  // PROMPT_GENERATING(4, "生图中", "剪辑中"),
  // FAILED(5, "失败", "剪辑失败"),
  // SUCCESS(6, "成功", "成功");

  // lastExportTaskStatus
  // INIT(0, "初始化", false, 0, 0),
  // GENERATE(1, "合成中", false, 1, 30),
  // COMPOSE_SUCCESS(2, "视频合成成功", true, 100, 100),
  // COMPOSE_FAILED(3, "视频合成失败", true, 100, 100),
  // ERROR(4, "失败-暂未使用", true, 100, 100),
  // TRANSITION(5, "转场特效生成中", false, 60, 90),
  // ZOOM_PAN(6, "微动生成中", false, 30, 60),
  // VIDEO_SPEED(7, "视频变速中", false, 50, 90),
  getStatusValue({ status, lastExportTaskStatus }) {
    const statusMap = ['init', 'wait', 'procecing', 'procecing', 'procecing', 'fail', 'success'];
    if (statusMap[status] === 'success') {
      const exportStatusMap = ['init', 'procecing', 'success', 'fail', 'fail', 'procecing', 'procecing'];
      return exportStatusMap[lastExportTaskStatus || 1] || '';
    }
    return statusMap[status] || '';
  }
  getStatusValueName({statusValue, statusName}) {
    if (statusValue === 'success') return '生成成功';
    if (statusValue === 'fail') return '生成失败';
    return statusName;
  }
  getProgress({ status, progress, exportProgress }) {
    const data = status === 6 ? exportProgress : progress;
    let process = 0;
    if(data) process = parseInt(data.match(/\d+/g)) || 0;
    if(status === 6 && !process) return ' ';
    return process + '%';
  }
  formatWorkItem(item) {
    item.statusValue = this.getStatusValue(item);
    item.statusValueName = this.getStatusValueName(item);
    item.progressValue = this.getProgress(item);
    if (item.statusValue === 'fail' && item.progress && item.progress.includes('敏感词')) {
      // title字符都替换为*
      item.title = item.title.replace(/./g, '*');
    }
    if (item.statusValue === 'success' && this.articleIdMigu) { 
      this.sendMgaEvent(item);
    }
    return item;
  }

  async getWorks() {
    this.loading = true;
    this.finished = false;

    let startDate = this.date.split('+')[0]
    let endDate = this.date.split('+')[1]
    let params = {
      page: this.pageIndex,
      size: this.pageSize,
      startDate: (() => {
        const now = new Date();
        now.setDate(now.getDate() - 7);
        // 补零
        const m = (now.getMonth() + 1).toString().padStart(2, '0');
        const d = now.getDate().toString().padStart(2, '0');
        return `${now.getFullYear()}-${m}-${d}`;
      })(),
      endDate: '',
      styleCode: this.type === '全部类型' ? '' : this.type,
    }
    const [err, res] = await to(this.$http("getArticleList", params))
    this.loading = false;
    this.finished = true;
    if (err) {
      this.pageIndex = 0;
      return this.$toast(err.message);
    }
    if (res.code !== 200 || !res.data) {
      this.pageIndex = 0;
      return this.$toast(res.message);
    }

    this.total_pages = res.data.total_pages;
    const list = (res.data.results || []).map((item) => {
      return this.formatWorkItem(item);
    })
    this.finished = false;
    this.works = this.pageIndex === 1 ? list : [...this.works, ...list];
    if (this.pageIndex >= this.total_pages) {
      this.finished = true;
    }
    this.statusUpdateQueue = this.works.filter(item => ['init', 'procecing', 'wait'].includes(item.statusValue));
  }

  async queryArticleStatusBatch() {
    if (this.statusUpdateQueue.length === 0) return;
    const articleIds = this.statusUpdateQueue.map((item) => item.articleId).join(",");
    const [error, res] = await to(this.$http("getArticleStatusBatch", { articleIds }));
    const list = res && res.data || [];
    if (!error && res.code === 200 && list.length) {
      list.forEach((resItem) => {
        const item = this.works.find((v) => v.articleId === resItem.articleId);
        if (item) {
          delete resItem.rank;
          Object.assign(item, resItem);
          this.formatWorkItem(item);
          if (!['init', 'procecing', 'wait'].includes(item.statusValue)) {
            this.statusUpdateQueue = this.statusUpdateQueue.filter(
              (v) => v.articleId !== item.articleId
            );
          }
        }
      });
    }
    if (this.statusUpdateQueue.length > 0) {
      this.statusUpdateTimer = setTimeout(this.queryArticleStatusBatch, 5000);
    }
  }

  /************************************************ 筛选项 *****************************************/
  //选择一种类型
  choose(item, key) {
    if (item == 'allDate') {
      this.date = '全部日期';
      this.dateValue = '全部日期';
      return
    }
    this.activeKey = key;
  }
  //重置所有
  resetFilters() {
    this.type = '全部类型';
    this.date = '全部日期';
    this.dateValue = '全部日期';
    this.activeKey = 0;
    this.activeValue = this.styles[this.activeKey].name;
    this.reloadWorks()
  }
  reloadWorks() {
    this.pageIndex = 1;
    this.total_pages = 0;
    this.getWorks();
  }
  getStyles() {
    this.$http("getStyle", { pageSize: 50 }).then(res => {
      if (res.code == 200) {
        this.styles = res.data.results
        this.styles.unshift({ 'id': 0, 'name': "全部类型", nameEN: '' });
      }
    })
  }

  //重置
  reset() {
    this.activeKey = 0;
    this.activeValue = this.styles[this.activeKey].name;
    if (this.showTypesPopover) {
      this.type = '全部类型';
    } else {
      this.date = '全部日期';
      this.dateValue = '全部日期';
    }
    this.showTypesPopover = false;
    this.showDatePopover = false;
    this.reloadWorks();
  }
  //选择类型-完成
  finishType() {
    this.showTypesPopover = false;
    this.type = this.styles[this.activeKey].nameEN;
    this.activeValue = this.styles[this.activeKey].name;
    this.reloadWorks();
  }
  //选择日期完成
  finishDate() {
    this.showDatePopover = false;
    this.reloadWorks();
  }
  //格式化日期
  formatDate(date, type) {
    let year = date.getFullYear();
    let month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    return type == 'dot' ? `${year}.${month}.${day}` : `${year}-${month}-${day}`;
  }
  //选中日期
  onConfirmDate(date) {
    this.show = false;
    this.showDatePopover = false;
    this.date = this.formatDate(date[0], '') + '+' + this.formatDate(date[1], '');
    this.dateValue = this.formatDate(date[0], 'dot') + '-' + this.formatDate(date[1], 'dot')
    this.reloadWorks();
  }
  sendMgaEvent(item) {
    if (item.articleId != this.articleIdMigu) {
      return;
    }
    if ((window as any)._amberTrack) {
      const vuid = localStorage.getItem('vuid') || '';
      const creationTaskId = localStorage.getItem('creationTaskIdMigu') || '';
      console.log('_amberTrack music_aigc_complete_task',
      {
        EK: 'taskId',
        EV: creationTaskId
      },
      {
        EK: 'videoUrl',
        EV: item.lastExportVideoUrl || ''
      },
      {
        EK: 'vuid',
        EV: vuid
      });
      (window as any)._amberTrack('music_aigc_complete_task', [
        {
          EK: 'triggerType',
          EV: '2'
        },
        {
          EK: 'scene',
          EV: MiguConfig.projectId
        },
        {
          EK: 'taskId',
          EV: creationTaskId
        },
        {
          EK: 'videoUrl',
          EV: item.lastExportVideoUrl || ''
        },
        {
          EK: 'vuid',
          EV: vuid
        },
        {
          EK: 'appId',
          EV: MiguConfig.appid
        },
        {
          EK: 'channel',
          EV: MiguConfig.schannel
        }
      ], true, 'beacon');
      localStorage.removeItem('creationTaskIdMigu');
    }
  }
}
